<template>
  <div style="position: relative">
    <div class="count_center">
      <!-- <h1>数字物流联接世界</h1> -->
      <img style="width: 83%" src="@images/homeBg.png" alt="背景图" />
      <div style="position: absolute; top: 0">
        <div class="user-head-wrap">
          <div class="user-head">
            <img style="border-radius: 100px" :src="Authorization && Authorization.headPortraitUrl ? Authorization.headPortraitUrl : defaultavater" alt="用户头像" />
          </div>
        </div>
        <div class="user-info">
          <p class="user-name">
            {{ Authorization.namec||"未命名用户" }}
            <template v-if="Authorization && Authorization.authenticationInfoDTO.state === 3 && Authorization.authenticationInfoDTO.type">
              <span class="userTag" :style="{backgroundImage: `url(${ossPath}/pages/userCenter/auth-tag.png)`}">
                {{typeName || ''}}
              </span>
            </template>
<!--        <template v-if="Authorization && (Authorization.authenticationInfoDTO.state === -1 || Authorization.authenticationInfoDTO.state === 2) && Authorization.authenticationInfoDTO.type">-->
            <template v-if="Authorization && Authorization.authenticationInfoDTO.state === -1 && Authorization.authenticationInfoDTO.type">
                <img :src="ossPath + '/pages/userCenter/realName.png'" alt="#" @click="toRealName" class="real-name">
            </template>
          </p>
          <div class="user-code" style="text-align: center;">
            <span style="color: #999"> 登录账号</span>
            {{ Authorization.username }} <span class="text-color"></span>
            <span style="color: #999"> 手机号</span>
            <span>{{ Authorization.phoneNo }}</span>
            <template v-if="realNameState === 3 && [2,6].includes(realNameType)">
              <span class="text-color"></span>
              <el-popover
                placement="top-start"
                width="180"
                trigger="hover"
                @show="getAppletQrCode"
                title=""
                content="">
                <span slot="reference">
                  <span style="color: #999;">邀请码</span>
                  <span>{{ Authorization.inviteCode }}</span>
                  <i class="el-icon-share"></i>
                </span>
                <div class="text-center" style="min-height: 180px;">
                  <img :src="qrCodeUrl" style="width: 120px;height: 120px;border:none;display: inline-block;margin-bottom: 12px;">
                  <template v-if="qrCodeLoading">
                    <p>正在获取小程序二维码</p>
                  </template>
                  <template v-else-if="qrCodeGetStatus === 1 && qrCodeUrl">
                    <p>扫描小程序二维码去小程序邀请销售代理注册</p>
                  </template>
                  <template v-else-if="qrCodeGetStatus === 2">
                    <p>获取小程序邀请码失败,<el-button type="primary" plain size="mini" @click="getAppletQrCode" :disabled="qrCodeLoading">点击重试</el-button></p>
                  </template>

                </div>
              </el-popover>
            </template>
          </div>
        </div>
<!--        <p>供应链金融当前 applyState = {{applyState}}，切换为<el-button @click="applyState = index" v-for="(item,index) in Array(6).fill(1)" :key="index">{{index}}</el-button></p>-->
        <div class="amount-wrap flex align-start justify-between">
          <div class="amount-wrap-item">
            <div>
              <p class="amount-value">
                {{ balanceInfo.count || 0 }}
              </p>
              <p>优惠券</p>
            </div>
            <el-button size="medium" type="primary" @click="clickCouponNumber">查看</el-button>
          </div>
          <div class="amount-wrap-item" v-if="realNameType === 1 && realNameState === 3">
            <template v-if="applyState === 1">
              <div>
                <p class="amount-value">平台审核中</p>
                <p>供应链金融授信额度</p>
              </div>
            </template>
            <template v-else-if="applyState === 2">
              <div>
                <p class="amount-value">银行审核中</p>
                <p>供应链金融授信额度</p>
              </div>
            </template>
            <template v-else-if="applyState === 3">
              <div>
                <p class="amount-value">平台审核失败</p>
                <p>供应链金融授信额度</p>
                <!--{{applyStateData.failureReason}}-->
              </div>
            </template>
            <template v-else-if="applyState === 4">
              <div>
                <p class="amount-value"> {{ applyStateData.creditLine || 0 | toPrice }}</p>
                <p>供应链金融授信额度</p>
              </div>
            </template>
            <template v-else-if="applyState === 5">
              <div>
                <p class="amount-value">银行审核失败</p>
                <p>供应链金融授信额度</p>
                <!--{{applyStateData.failureReason}}-->
              </div>
            </template>
            <template v-else>
              <div>
                <p class="amount-value">500,000.00</p>
                <p>预估供应链金融授信额度</p>
              </div>
              <el-button
                style="width: 100px"
                size="medium"
                type="primary"
                @click="goApplyPage"
              >去申请</el-button>
            </template>

          </div>
          <div class="amount-wrap-item">
            <div>
              <p class="amount-value">
                {{ balanceInfo.totalBalance | toPrice }}
              </p>
              <p>账户可用金额</p>
            </div>
            <el-button
              style="width: 100px"
              size="medium"
              type="primary"
              @click="payVisible = true"
              >充值</el-button
            >
          </div>
          <div class="amount-wrap-item">
            <div>
              <p class="amount-value">
                {{ balanceInfo.oweAmount | toPrice }}
              </p>
              <p>当前剩余应还</p>
            </div>
            <el-button size="medium" type="primary" @click="enterBillOrder"
              >查看欠费详情</el-button
            >
          </div>
        </div>
        <PayDialog
          :visible="payVisible"
          @close="closePay"
          @show="payVisible = true"
          @amountChange="amountChange"
        />
      </div>
      <!-- 选择实名认证类型 start -->
      <real-name-type-select
        :show="realNameTypeVisible"
        @toRealName="showRealNameDialog"
        @close="selectRealnameTypeClose"
        :type="realNameType">
      </real-name-type-select>
      <!-- 选择实名认证类型 end -->
      <!-- 实名认证 start -->
      <user-manageinfo
        :dialogTableVisible="realNameVisible"
        @closedialog="closedialog"
        @getUserLoginInfo="getUserLoginInfo"
        ref="mychild"
        :realNameType="authType"
      ></user-manageinfo>
      <!-- 实名认证-End -->
      <el-dialog
        :title="realNameAuthenticationTitle"
        :visible.sync="visibleRealNameAuthentication"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        width="540px"
        @close="hideRealNameAuthentication"
      >
        <real-name-authentication-partner
          ref="authenticationPartner"
          :partner-type="authenticationType === 2 ? 2 : (checkAuthenticationType ? checkAuthenticationType : 1)"
          @success="realNameAuthenticationSuccess"
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import PayDialog from "./components/pay-dialog";
import qs from "qs";
import {mapGetters, mapState} from "vuex";
import {loginSaveUserData} from "@/assets/js/utils.login";
import navlistBus from "./components/navlistBus.js";
import {isObject} from "my-tools-kit";
import realNameTypeSelect from "./components/real-name-type-select.vue";
import userManageinfo from "./accountManage/UserManageinfo/UserManageinfo.vue";
import realNameAuthenticationPartner from "./accountManage/realNameAuthentication/realNameAuthenticationPartner.vue";
const defaultavater = require('@images/user.png')

export default {
  components: { PayDialog, realNameTypeSelect, userManageinfo, realNameAuthenticationPartner },
  data() {
    return {
      defaultavater,
      ossPath: 'https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0',
      payVisible: this.$store.state.payVisible,
      balanceInfo: {},
      // 供应链金融 申请状态 0-未提交 1-平台审核中  2-银行审核中 3-平台审核失败  4-审核成功  5-银行审核失败
      applyState:0,
      // 供应链金融 获取的申请状态数据对象
      applyStateData:{
        // 授信额度
        creditLine:0,
        // 审核失败原因
        failureReason:"",
      },
      // 小程序码路径
      qrCodeUrl:"",
      qrCodeLoading:false,
      // 小程序码获取状态 0-未获取 1-成功 2-失败
      qrCodeGetStatus:0,
      realNameTypeVisible: false,
      realNameVisible: false,
      authenticationInfoDTO: null,
      // 实名认证弹窗（合伙人）
      visibleRealNameAuthentication:false,
      realNameAuthenticationTitle:"城市合伙人认证",
      // 城市合伙人认证类型 1-公司 2-个人
      checkAuthenticationType: null,
      selectRealNameTypeCode: null,
    };
  },
  computed: {
    ...mapState(["Authorization"]),
    ...mapGetters(["realNameType","realNameState","authenticationType"]),
    typeName() {
      let title = ''
      let type = this.realNameType;
      let typeMap = {
        1:"销售代理",
        2:"分销大使",
        3:"省代",
        4:"市代/产业带加盟商",
        5:"",
        6:"城市合伙人",
        7:"货代询价用户"
      }
      title = typeMap[type];
      if(type === 6){
        if(this.authenticationType === 2){
          // title += "-个人";
        }else{
          // title += "-公司";
        }
      }
      return title
    },
    authType() {
      if (this.realNameType && this.realNameType != -1) {
        return this.realNameType
      } else if (this.selectRealNameTypeCode) {
        return this.selectRealNameTypeCode
      } else return null
    }
  },
  created() {},
  mounted() {
    if (this.sessionGetUserInfo().token) {
      this.checkAuth();
      this.getApplyState();
    }
    if (this.$route.query.qrCode2) {
      let data = {
        code: this.$route.query.qrCode2,
      };
      if (sessionStorage.getItem("tagType") == 1) {
        this.getInfo();
        this.getApplyState();
        return;
      }
      this.axios
        .post(`/user/loginByWechatCode`, qs.stringify(data))
        .then((resData) => {
          if (resData.data.code == 200) {
            this.$store.state.Authorization = resData.data.data;
            this.info = resData.data.data;
            const mobilePhone = JSON.stringify({
              account: resData.data.data.mobilePhone,
              activeName: 0
            })
            localStorage.setItem('login-account', mobilePhone)
            this.getInfo2(resData.data.data.customerid);
            this.getApplyState();
            navlistBus.$emit("navlistToindex", resData.data.data.authorities);
            sessionStorage.setItem(
              "Authorization",
              JSON.stringify(resData.data.data)
            );
            this.$message({
              type: "success",
              message: "登录成功",
            });
            //  console.log('resData.data.data.isBindedWebOpenId: ', resData.data.data.isBindedWebOpenId);
            //           if(resData.data.data.isBindedWebOpenId){
            //             this.visiable = true
            //           }
            // 割掉qrCode二次调用接口
            sessionStorage.setItem("tagType", 1);
          } else {
            this.$message({
              type: "error",
              message: resData.data.message,
            });
          }
        });
    } else {
      // 免密用户登录信息
      let noSecretData = this.$route.query;
      // 非免密登录，直接返回
      if (
        noSecretData === undefined ||
        noSecretData.code === undefined ||
        noSecretData.password === undefined
      ) {
        this.getInfo();
        this.getApplyState();
        return;
      }
      // 是否已有用户登录
      let userAuth = this.Authorization;

      // 不管有没有登录信息，直接登录
      this.userNamerNext = noSecretData.code;
      this.passwordNext = noSecretData.password;
      this.nextLoginQd(noSecretData.noSecret);
    }

    // 无登录信息，直接免密登录
    // if (userAuth === null || userAuth.username === noSecretData.code) {
    //   this.userNamerNext = noSecretData.code;
    //   this.passwordNext = noSecretData.password;
    //   this.nextLoginQd(noSecretData.noSecret);
    //   return;
    // }
    // 有登录信息，且非重复登录，覆盖登录
    // this.$confirm("当前已有用户登录，是否注销并登录?", "提示", {
    //   confirmButtonText: "确定",
    //   cancelButtonText: "取消",
    //   type: "warning",
    // })
    //   .then(() => {
    //     this.userNamerNext = noSecretData.code;
    //     this.passwordNext = noSecretData.password;
    //     this.nextLoginQd(noSecretData.noSecret);
    //   })
    //   .catch(() => {
    //     this.$router.push("/");
    //   });
  },
  methods: {
    async checkAuth() {
      const result = await this.axios.get(`/user/getUserLoginInfo/1`).catch((res) => {})
      if (result) {
        this.$store.commit("addUserdata", result.data.data)
      } else {
        this.$message.warning('获取当前用户最新信息失败')
      }
    },
    // 直接登录
    nextLoginQd(noSecret) {
      // 免密登录标识 noSecret 0.否 1.是
      let that = this;
      if (this.passwordNext && this.userNamerNext) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // let params = {};
        let params = {
          password: this.passwordNext,
          username: this.userNamerNext,
        };
        let headers = {};
        // 普通登录路径
        let url = "/user/login";
        // 是否免密登录路径
        if (noSecret === "1") {
          url = "/user/noSecretLogin";
          headers = {
            headers: { noSecret: noSecret},
          };
        }
        this.axios
          .post(url, qs.stringify(params), headers)
          .then((res) => {
            if (res.data.code == "200") {
              loginSaveUserData(res.data.data);
              that.realNameVisible = false;
              loading.close();
              if (this.logintType == 2) {
                that.$parent.getFiledata("login");
              }
              // this.$store.commit("setnavList", res.data.data.authorities);
              navlistBus.$emit("navlistToindex", res.data.data.authorities);
              that.$message({ message: "登录成功", type: "success" });
              let itemMenu = {
                // 免密登录 跳转我得钱包 保存标签
                code: "/index/PersonalCenter/Personalindex/PersonalCenter/userCountshow",
                icon: null,
                level: 2,
                name: "我的钱包",
                nextNodes: null,
                parentId: 21,
                resourceId: 38,
              };
              this.$store.commit("mutationSelectTags", itemMenu);
              this.$store.commit("changeactive", 7); //免密登录的header标签 不显示
              this.getInfo();
              this.getApplyState();
            } else {
              that.$message.info(res.data.message);
              loading.close();
            }
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    getInfo() {
      let id = JSON.parse(localStorage.getItem("Authorization"));
      this.axios
        .get(`/indexRecharge/getCustomerAccountInfo/${id.customerid}`)
        .then((res) => {
          if (res.data.code === 0) {
            this.balanceInfo = res.data.data;
          }
        });
    },
    getInfo2(val) {
      this.axios
        .get(`/indexRecharge/getCustomerAccountInfo/${val}`)
        .then((res) => {
          if (res.data.code === 0) {
            this.balanceInfo = res.data.data;
          }
        });
    },
    closePay() {
      this.payVisible = false;
    },
    enterBillOrder() {
      let data = JSON.parse(localStorage.getItem("Authorization"));
      console.log("look---", data);
      // return
      if (!data.authorities) {
        this.$message({
          type: "warning",
          message: "该用户暂无权限，请联系管理员分配权限",
        });
        return;
      }
      sessionStorage.setItem("billOrderType", "1");
      this.$router.push(
        "/index/PersonalCenter/Personalindex/PersonalCenter/billType/Mybill"
      );
      let itemMenu = {
        code: "/index/PersonalCenter/Personalindex/PersonalCenter/billType/Mybill",
        icon: null,
        level: 2,
        name: "我的费用",
        nextNodes: null,
        parentId: 21,
        resourceId: 22,
      };
      this.$store.commit("mutationSelectTags", itemMenu);
    },
    amountChange() {
      this.getInfo();
    },
    /**
     * 查询供应链金融审核状态
     */
    getApplyState(){
      let customerId = this.$store.getters.customerId;
      if(!customerId) return false;
      let url = `/api/busFinancial/getCustomState/${customerId}`;
      let data = {
        corporationId:customerId,
      };
      this.axios.get(url)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let data = res.data || {};
          let {
            status = 0,
          } = data;
          this.applyState = status;
          this.applyStateData = data;
        })
        .catch(res=>{
          this.$message.error(`查询审核状态：${res.message||"网络异常，请稍后重试"}`);
        })
    },
    /**
     * 调整供应链金融申请页
     */
    goApplyPage(){
      this.$store.commit("changeactive", 8)
      this.$store.commit("emptyList") //清空个人中心标签
      this.$router.push({ name: "supplyChainFinanceApply" })
      this.$store.commit("changeSetType", true)
      this.$store.commit("changeLogoshow", false) //关闭logo
    },
    /**
     * 点击查看优惠券
     */
    clickCouponNumber(){
      this.$router.push({path:'/index/PersonalCenter/Personalindex/PersonalCenter/billType/coupon',query:{type:2,}})
      let item = {
        "name": "我的优惠券",
        "code": "/index/PersonalCenter/Personalindex/PersonalCenter/billType/coupon",
        "icon": null,
        "resourceId": "",
        "level": 2,
        "parentId": "",
        "nextNodes": null
      }
      this.$store.commit("mutationSelectTags", item);
    },
    /**
     * 获取微信小程序邀请码
     * @returns {boolean}
     */
    getAppletQrCode(){
      if(this.qrCodeLoading) return false;
      if(this.qrCodeGetStatus === 1) return false;
      let inviteCode = this.Authorization.inviteCode||"";
      let url = "/api/wechatUser/generateWxCode";
      // loginInfo/registerPage 是小程序活动邀请注册页面
      let data = {
        scene:`v=${inviteCode}`,
        path:"loginInfo/registerPage",
      };
      this.qrCodeLoading = true;
      this.axios.post(url,data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.qrCodeLoading = false;
          this.qrCodeGetStatus = 1;
          this.qrCodeUrl = res.message || "";
        })
        .catch(res=>{
          this.qrCodeLoading = false;
          this.qrCodeGetStatus = 2;
          this.qrCodeUrl = "";
          this.$message.error(`获取小程序码：${res.message||"网络异常，请稍后重试"}`);
        })
    },
    toRealName() {
      this.realNameTypeVisible = true
    },
    /**
     * 显示实名认证提交弹窗
     * @param type  {number}  实名认证类型
     */
    showRealNameDialog(type, atype) {
      console.log(atype)
      this.selectRealnameTypeClose()
      if(type === 6){
        // 城市合伙人
        this.checkAuthenticationType = atype
        this.showRealNameAuthentication()
      }else{
        // 其他销售代理等
        this.realNameVisible = true;
        console.log(this.$refs.mychild)
        this.$refs.mychild.parentHandleclick();
        this.selectRealNameTypeCode = type
      }

    },
    /**
     * 关闭 选择实名认证类型 弹窗
     */
    selectRealnameTypeClose() {
      this.realNameTypeVisible = false
    },
    /**
     * 关闭 查看实名认证资料 弹窗
     */
    closedialog() {
      this.realNameVisible = false;
    },
    getUserLoginInfo() {
      let user = this.sessionGetUserInfo();
      this.$http
        .get("/user/getUserLoginInfo/1", {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: user.token,
          },
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          loginSaveUserData(res.data.data);
          this.authenticationInfoDTO = res.data.data.authenticationInfoDTO;
          console.log(
            "this.authenticationInfoDTO: ",
            this.authenticationInfoDTO
          );
          let userdata = res.data.data.authenticationInfoDTO;
          if (userdata.type == 1) {
            //企业
            this.LicImgurl = userdata.fileUrls[0] || "";
          } else {
            //个人
            this.sfzzImgurl = userdata.fileUrls[0] || "";
            this.sfzfImgurl = userdata.fileUrls[1] || "";
          }
          console.log("sessionGetUserInfo", res.data.data);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    /**
     * 展示 实名认证(合伙人) 弹窗
     */
    showRealNameAuthentication(){
      let partnerType = this.authenticationType === 2 ? 2 : 1;
      if (this.checkAuthenticationType) partnerType = this.checkAuthenticationType
      let label = partnerType === 2 ? "个人申请" : "公司申请";
      this.realNameAuthenticationTitle = `城市合伙人入驻`;
      this.visibleRealNameAuthentication = true;
    },
    /**
     * 隐藏 实名认证(合伙人) 弹窗
     */
    hideRealNameAuthentication(){
      let $authenticationPartner = this.$refs.authenticationPartner;
      if($authenticationPartner && $authenticationPartner.resetData) $authenticationPartner.resetData();
      this.visibleRealNameAuthentication = false;
    },
    /**
     * 实名认证(合伙人) 成功
     */
    realNameAuthenticationSuccess(){
      this.hideRealNameAuthentication();
      this.getUserLoginInfo();
    },
  },
};
</script>
<style scoped>
h1 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding: 54px;
  box-sizing: border-box;
}

.count_center {
  margin-top: 72px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
<style lang="scss" scoped>
.flex {
  display: flex;

  &.align-center {
    align-items: center;
  }

  &.justify-between {
    justify-content: space-between;
  }

  &.justify-around {
    justify-content: space-around;
  }
}

.user-head-wrap {
  // position: relative;
  margin: 20px auto;
  margin-top: 70px;
  width: 104px;

  .user-head {
    width: 100%;
    height: 104px;
    border-radius: 55px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.user-info {
  margin-bottom: 83px;

  p {
    text-align: center;
    font-size: 18px;

    &.user-name {
      margin-bottom: 15px;
      font-size: 24px;
    }

    &.user-code > span:first-of-type {
      margin-left: 15px;
    }
  }
}

.amount-wrap {
  margin: 5px auto;
  //width: 380px;
  font-size: 16px;

  .amount-wrap-item {
    margin-bottom: 20px;
    line-height: 30px;
    text-align: center;
    & + .amount-wrap-item{
      margin-left: 30px;
    }
    .amount-value {
      font-size: 36px;
    }

    p:not(.amount-value) {
      line-height: 60px;
    }
  }
}

.goodNews {
  position: relative;
  border: 1px solid #f8834d;
  padding: 35px;
  padding-top: 40px;
  line-height: 26px;
  color: #f8834d;

  ::before {
    content: "赠送规则";
    display: block;
    position: absolute;
    padding: 2px 15px;
    top: 0;
    left: 0;
    color: #fff;
    background: #f8834d;
    border-radius: 0 0 20px 0;
  }
}

.text-color {
  display: inline-block;
  width: 1px;
  height: 14px;
  background-color: #999;
  margin: 0px 14px;
}
.userTag {
  display: inline-block;
  padding-left: 48px;
  min-width: 117px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 18px;
  color: #F4AF2F;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: -13px;
  background-size: auto 100%;
  background-repeat: no-repeat;
}
.real-name {
  width: 80px;
  height: 31px;
  vertical-align: bottom;
  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/userCountshow.vue